var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.91 107.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6db33f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-spring-cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.75,87.2a3.21,3.21,0,1,1-.47-4.52A3.21,3.21,0,0,1,52.75,87.2Zm51-11.25C94.45,88.3,74.66,84.14,62,84.73c0,0-2.25.13-4.52.5,0,0,.86-.36,1.95-.74C68.32,81.41,72.53,80.79,78,78c10.17-5.21,20.3-16.56,22.36-28.36C96.44,61,84.66,70.75,73.93,74.72c-7.34,2.7-20.62,5.34-20.62,5.34l-.54-.28c-9-4.39-9.29-24,7.11-30.26,7.19-2.76,14.07-1.24,21.84-3.09,8.29-2,17.89-8.19,21.8-16.32C107.89,43.09,113.15,63.39,103.72,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.33,107.14H39.79A39.79,39.79,0,0,1,33.86,28C39,20.88,45.42,12.88,54.74,7.42a54.21,54.21,0,0,1,61.53,4.69l.1.09a77.49,77.49,0,0,1,11.68,12.51,39,39,0,0,1,6.64,12.74c.09.33.17.52.21.64.2.1.55.25.83.37l1.07.47a36.37,36.37,0,0,1,13.57,10.71,35.59,35.59,0,0,1-28,57.5ZM82.08,8a46.23,46.23,0,0,0-23.3,6.32c-8.05,4.72-13.86,12-18.47,18.41l-.19.28A5.61,5.61,0,0,1,36,35.78a31.79,31.79,0,0,0,3.8,63.36h82.54a27.59,27.59,0,0,0,21.73-44.58,28.58,28.58,0,0,0-6.55-6.1,29,29,0,0,0-4-2.26l-.89-.39A10.19,10.19,0,0,1,129.47,44,8.89,8.89,0,0,1,127,39.61a31,31,0,0,0-5.37-10.14A70,70,0,0,0,111.2,18.3,46.05,46.05,0,0,0,82.08,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringCloud);
export default __webpack_public_path__ + "static/media/spring-cloud.c98152db369ae78ddb68650845397350.svg";
export { ForwardRef as ReactComponent };